import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
/**
 * La clase `SidenavService` proporciona métodos para obtener información sobre el sidenav y gestionar su estado.
 */
export class SidenavService {
  canales: any;
  ultimosVideos: any;
  masVistos: any;
  public isOpenSubject = new BehaviorSubject<boolean>(false);
  private isScrolledSubject = new BehaviorSubject<boolean>(false);
  private isVisibleSubject = new BehaviorSubject<boolean>(true);

  /**
   * Abre el sidenav y obtiene los canales, cambiando en el estado del sidenav.
   * @returns void
   */
  public openSidenav() {
    this.getCanales();
    return this.isOpenSubject.next(true);
  }

  /**
   * Cierra el sidenav, cambiando en el estado del sidenav.
   * @returns void
   */
  public closeSidenav() {
    return this.isOpenSubject.next(false);
  }

  public getCanales() {
    return this.canales;
  }
  public getUltimosVideos() {
    return this.ultimosVideos;
  }

  /**
   * Establece el estado del scroll del sidenav.
   * @param {boolean} isScrolled
   */
  setIsScrolled(isScrolled: boolean): void {
    this.isScrolledSubject.next(isScrolled);
  }

  /**
   * Obtiene el estado del scroll del sidenav.
   * @returns Observable con el estado del scroll del sidenav.
   */
  getIsScrolled(): Observable<boolean> {
    return this.isScrolledSubject.asObservable();
  }

  /**
   * Establece la visibilidad del logo.
   * @param {boolean} isVisible - La visibilidad del logo.
   * @returns void
   */
  setLogoVisibility(isVisible: boolean): void {
    this.isVisibleSubject.next(isVisible);
  }

  /**
   * Obtiene la visibilidad del logo.
   * @returns Observable con la visibilidad del logo.
   */
  getLogoVisibility(): Observable<boolean> {
    return this.isVisibleSubject.asObservable();
  }
}
